<template>
  <w-modal
    v-model="show"
    class="payment-pack-filters"
    close-button="Anuluj"
    submit-button="Filtruj"
    :title="$schema.$title"
    :close-on-submit="false"
    :hide-on-overlay="true"
    :hide-on-esc="true"
    @submit="applyFilters"
    @close="close"
  >
    <w-select :model="$schema.status" :values="statuses" />

    <w-datepicker :model="$schema.createdDateFrom" />

    <w-datepicker :model="$schema.createdDateTo" />
  </w-modal>
</template>

<script>
import { Errors } from '@/enums/errors.enum';
import { PaymentState, PaymentStateTranslations } from '@/enums/paymentState';
import { formMixin } from '@/mixins/form';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';

export default {
  mixins: [formMixin, modalMixin, notificationsMixin],
  schema: {
    title: 'Filtry',
    properties: {
      status: {
        title: 'Status',
        type: 'string'
      },

      createdDateFrom: {
        title: 'Data utworzenia - od',
        type: 'string',
        format: 'date'
      },

      createdDateTo: {
        title: 'Data utworzenia - do',
        type: 'string',
        format: 'date'
      }
    }
  },

  data() {
    const statuses = Object.values(PaymentState)
      .filter((state, index, states) => !!PaymentStateTranslations[state] && states.indexOf(state) === index)
      .map(state => ({ value: state, text: PaymentStateTranslations[state] }));
    statuses.unshift({ value: null, text: 'Wszystkie' });
    return { statuses };
  },

  beforeMount() {
    this.$schema.$setData(this.$router.currentRoute.query);
  },

  methods: {
    applyFilters() {
      if (this.$schema.$validateAll().length) {
        this.notifyError(Errors.FORM_CORRECT_ERRORS);
        return;
      }

      this.$router.replace({ query: this.$schema.$getData() });
      this.close();
    }
  }
};
</script>
